import LOCATION_TYPES from 'shared/constants/locationTypes';

// Helpers

const withInjectLocations = (...locationTypes) => item => ({
  ...item,
  injectLocations: locationTypes,
});

//

const avto = [
  {
    title: 'Объявления',
    route: '/avto/',
    injectLocations: [LOCATION_TYPES.COUNTRY, LOCATION_TYPES.CITY],
  },
  // {
  //   title: 'Каталог',
  //   route: '/avto/catalog',
  // },
  {
    title: 'Автосалоны',
    route: '/avtosalony/',
    slug: '/avtosalony/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
];

const moto = [
  {
    title: 'Мотоциклы',
    route: '/mototsikl/',
    slug: '/mototsikl/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Скутеры',
    route: '/skuter/',
    slug: '/skuter/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Картинг',
    route: '/karting/',
    slug: '/karting/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Квадроциклы',
    route: '/kvadrotsikl/',
    slug: '/kvadrotsikl/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Мопеды',
    route: '/moped/',
    slug: '/moped/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Багги',
    route: '/baggi/',
    slug: '/baggi/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Трициклы',
    route: '/tritsikl/',
    slug: '/tritsikl/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
];

const truck = [
  {
    title: 'Грузовики',
    route: '/gruzovye/',
    slug: '/gruzovye/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Автобусы',
    route: '/avtobus/',
    slug: '/avtobus/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Прицепы',
    route: '/pritsepy/',
    slug: '/pritsepy/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Водный транспорт',
    route: '/vodnyi-transport/',
    slug: '/vodnyi-transport/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Спецтехника',
    route: '/spetstehnika/',
    slug: '/spetstehnika/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
];

const AVTOSALONS_LINKS = [
  {
    title: 'Авто',
    route: '/avtosalony/',
    slug: '/avtosalony/avto/',
  },
  {
    title: 'Мото',
    route: '/avtosalony/mototsikl/',
    slug: '/avtosalony/mototsikl/',
  },
  {
    title: 'Автобусы',
    route: '/avtosalony/avtobus/',
    slug: '/avtosalony/avtobus/',
  },
  {
    title: 'Грузовики',
    route: '/avtosalony/gruzovye/',
    slug: '/avtosalony/gruzovye/',
  },
  {
    title: 'Водный транспорт',
    route: '/avtosalony/vodnyi-transport/',
    slug: '/avtosalony/vodnyi-transport/',
  },
  {
    title: 'Спецтехника',
    route: '/avtosalony/spetstehnika/',
    slug: '/avtosalony/spetstehnika/',
  },
  {
    title: 'Прицепы',
    route: '/avtosalony/pritsepy/',
    slug: '/avtosalony/pritsepy/',
  },
];

const FIRMS_TAGS_LINKS = [
  {
    title: 'СТО',
    route: '/katalog-kompaniy/sto/',
    slug: '/katalog-kompaniy/sto/',
  },
  {
    title: 'Авторазборка',
    route: '/katalog-kompaniy/avtorazborka/',
    slug: '/katalog-kompaniy/avtorazborka//',
  },
  {
    title: 'Автовыкуп',
    route: '/katalog-kompaniy/avtovykup/',
    slug: '/katalog-kompaniy/avtovykup/',
  },
  {
    title: 'Запчасти',
    route: '/katalog-kompaniy/zapchasti/',
    slug: '/katalog-kompaniy/zapchasti/',
  },
  {
    title: 'Автотовары',
    route: '/katalog-kompaniy/avtotovary/',
    slug: '/katalog-kompaniy/avtotovary/',
  },
  {
    title: 'ТСЦ',
    route: '/katalog-kompaniy/teritorialni-servisni-centri/',
    slug: '/katalog-kompaniy/teritorialni-servisni-centri/',
  },
];

const HEADER = [
  {
    title: 'Легковые',
    route: '/avto/',
    name: 'avto',
    items: [
      {
        title: 'C пробегом',
        route: '/avto/',
        injectLocations: [LOCATION_TYPES.COUNTRY, LOCATION_TYPES.CITY],
      },
      {
        title: 'Новые',
        route: '/avto/novye/',
        injectLocations: [LOCATION_TYPES.CITY],
      },
      // {
      //   title: 'Каталог',
      //   route: '/avto/catalog',
      // },
      {
        title: 'Автосалоны',
        route: '/avtosalony/',
        injectLocations: [LOCATION_TYPES.CITY],
      },
      {
        title: 'Лизинг авто',
        route: '/leasing/',
        injectLocations: [LOCATION_TYPES.CITY],
      },
    ],
    injectLocations: [LOCATION_TYPES.COUNTRY, LOCATION_TYPES.CITY],
  },
  {
    title: 'Мото',
    route: '/moto/',
    items: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Коммерческие',
    route: '/commercial/',
    items: truck.map(withInjectLocations(LOCATION_TYPES.CITY)),
    injectLocations: [LOCATION_TYPES.CITY],
    // {
    //   title: 'Спецтехника',
    //   route: '/spetstehnika/',
    //   items: [
    //     {
    //       title: 'Автокран',
    //       route: '/avtokran',
    //     },
    //     {
    //       title: 'Бульдозеры',
    //       route: '/buldozer',
    //     },
    //     {
    //       title: 'Автопогрузчики',
    //       route: '/avtopogruzchik',
    //     },
    //     {
    //       title: 'Эскаваторы',
    //       route: '/ekskavator',
    //     },
    //     {
    //       title: 'Самопогрузчики',
    //       route: '/samopogruzchik',
    //     },
    //     {
    //       title: 'Коммунальная',
    //       route: '/kommunalnaya',
    //     },
    //     {
    //       title: 'Cтроительная техника',
    //       route: '/stroitelnaya',
    //     },
    //   ],
    // },
  },
  {
    title: 'Запчасти',
    route: '/zapchasti/',
    injectLocations: [LOCATION_TYPES.CITY],
    items: [
      // {
      //   title: 'Запчасти',
      //   route: '/zapchasti/',
      //   injectLocations: [LOCATION_TYPES.CITY],
      // },
      // {
      //   title: 'Новые',
      //   route: '/zapchasti?isNew=1',
      // },
      // {
      //   title: 'Б/y',
      //   route: '/zapchasti?isUsed=1',
      // },
      // {
      //   title: 'Каталог компаний',
      //   route: '/katalog-kompaniy/',
      //   injectLocations: [LOCATION_TYPES.CITY],
      // },
    ],
  },
  {
    title: 'Автосалоны',
    route: '/avtosalony/',
    items: AVTOSALONS_LINKS,
  },
  {
    title: 'Каталог',
    route: '/katalog-kompaniy/sto/',
    items: FIRMS_TAGS_LINKS,
    injectLocations: [LOCATION_TYPES.CITY],
  },
  // {
  //   title: 'Журнал',
  //   route: '/zhurnal/',
  //   items: [
  //     {
  //       title: 'Видео',
  //       route: '/zhurnal/video/',
  //     },
  //     {
  //       title: 'Новости',
  //       route: '/zhurnal/',
  //     },
  //     {
  //       title: 'Акции',
  //       route: '/zhurnal/aktsii/',
  //     },
  //     {
  //       title: 'Статьи',
  //       route: '/zhurnal/stati/',
  //     },
  //     {
  //       title: 'Тест-драйвы',
  //       route: '/zhurnal/test-draiv/',
  //     },
  //     {
  //       title: 'Обзоры',
  //       route: '/zhurnal/obzory/',
  //     },
  //   ],
  // },
  {
    title: 'Сервисы',
    route: '/service/ocenka-avto/',
    items: [
      {
        title: 'Оценка стоимости авто',
        route: '/service/ocenka-avto/',
      },
      {
        title: 'Пригон авто',
        route: '/service/prygon-avto/',
      },
      {
        title: 'Страховка',
        route: '/insurance/orders/',
      },
      {
        title: 'Подписки на поиск',
        route: '/service/search-subscriptions/',
      },
    ],
  },
];

const FOOTER = [
  //

  {
    title: 'Разместить рекламу',
    route: '/advertising/',
  },
  {
    title: 'Бизнесу',
    route: '/biznes-paket/',
  },
  {
    title: 'Автосалонам',
    route: '/for-dealers/',
  },
  {
    title: 'Запчасти',
    route: '/info-zapchasti/',
  },
  {
    title: 'Автосервисам',
    route: '/for-services/',
  },
  {
    title: 'Помощь',
    route: '/help/',
  },
  {
    title: 'Частным лицам',
    route: '/for-privates/',
  },
  // {
  //   title: 'О проекте',
  //   route: '/about/',
  // },
];



const SPARES_LINKS = [
  {
    title: 'Авто',
    route: '/zapchasti/',
    slug: '/zapchasti/avto/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Мото',
    route: '/zapchasti/moto/',
    slug: '/zapchasti/moto/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Автобусы',
    route: '/zapchasti/avtobus/',
    slug: '/zapchasti/avtobus/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Грузовики',
    route: '/zapchasti/gruzovye/',
    slug: '/zapchasti/gruzovye/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Водный транспорт',
    route: '/zapchasti/vodnyi-transport/',
    slug: '/zapchasti/vodnyi-transport/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Спецтехника',
    route: '/zapchasti/spetstehnika/',
    slug: '/zapchasti/spetstehnika/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
  {
    title: 'Прицепы',
    route: '/zapchasti/pritsepy/',
    slug: '/zapchasti/pritsepy/',
    injectLocations: [LOCATION_TYPES.CITY],
  },
];

const PROFILE = [
  {
    title: 'Мои объявления',
    route: '/my/',
  },
  {
    title: 'Сообщения',
    route: '/dialogs/',
  },
  {
    title: 'Баланс',
    route: '/billing/',
  },
  {
    title: 'Избранное',
    route: '/favorites/',
  },
  // {
  //   title: 'Мои поиски',
  //   route: '/my-searches',
  // },
  {
    title: 'Страховка',
    route: '/insurance/orders/',
  },
  {
    title: 'Подписки на поиск',
    route: '/service/search-subscriptions/',
  },
  {
    title: 'Настройки',
    route: '/profile/',
  },
];

const SEARCH = {
  avto,
  //
  moto: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  mototsikl: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  skuter: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  karting: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  kvadrotsikl: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  tritsikl: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  moped: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  baggi: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  snegohod: moto.map(withInjectLocations(LOCATION_TYPES.CITY)),
  //
  gruzovye: truck.map(withInjectLocations(LOCATION_TYPES.CITY)),
  avtobus: truck.map(withInjectLocations(LOCATION_TYPES.CITY)),
  pritsepy: truck.map(withInjectLocations(LOCATION_TYPES.CITY)),
  spetstehnika: truck.map(withInjectLocations(LOCATION_TYPES.CITY)),
  'vodnyi-transport': truck.map(withInjectLocations(LOCATION_TYPES.CITY)),
};

const SPARES = [
  // {
  //   title: 'Запчасти',
  //   route: '/zapchasti/',
  // },
  // {
  //   title: 'Новые',
  //   route: '/zapchasti?isNew=1',
  // },
  // {
  //   title: 'Б/y',
  //   route: '/zapchasti?isUsed=1',
  // },
  // {
  //   title: 'Каталог компаний',
  //   route: '/katalog-kompaniy/',
  // },
];

const LINKS = {
  HEADER,
  FOOTER,
  PROFILE,
  SEARCH,
  SPARES,
  AVTOSALONS_LINKS,
  FIRMS_TAGS_LINKS,
  SPARES_LINKS,
  moto,
};

export default LINKS;



// WEBPACK FOOTER //
// ./src/desktop/constants/navigation.js